const formatAllToLowerCase = (text: string = "") => {
	return text.toLowerCase();
};

export default formatAllToLowerCase;
